module.exports = __webpack_public_path__ + "img/star-filled-20x20.41a5c4c1.svg";